import R from "ramda";
import { http } from "api/http";

export const fetchCurrentUserAndAccounts = () => http.get("/user").then(response => {
  const user = R.pick(["id", "firstName", "lastName", "email"], response.data);
  const rawAccountData = R.path(["data", "accounts"], response);
  const accounts = rawAccountData.map(data => R.pick(["id", "label", "slug", "preferredCurrency"], data));

  return {
    accounts,
    response,
    user
  };
});



// WEBPACK FOOTER //
// ./src/js/api/users.js